import { Pane } from "./pane";
import { LineItem } from "../renderers/line-renderer";
import { IDataSource } from "./idata-source";
import { DGDrawingServiceGlobal } from "src/app/Services/DrawingService";

class Point2D {
    public x: number;
    public y: number;

    constructor(x:number,y:number)
    {
        this.x = x;
        this.y = y;
    }

    public len(p:Point2D):number {
        return Math.sqrt( (this.x-p.x)*(this.x-p.x) + (this.y-p.y)*(this.y-p.y) );
    }
}

class Line2D {
    public s: Point2D;
    public e: Point2D;
    public id: number;
    public data: LineItem;
    public paneID : number;
    public serie: IDataSource;

    constructor(x0:number,y0:number,x1:number,y1:number,id:number,data: LineItem,paneID : number,serie: IDataSource)
    {
        this.s = new Point2D(x0,y0);
        this.e = new Point2D(x1,y1);
        this.id = id;
        this.data = data;
        this.paneID = paneID;
        this.serie = serie;
    }

    public static fromPoints(s:Point2D,e:Point2D,id:number,data: LineItem,paneID : number,serie: IDataSource) : Line2D
    {
        return new Line2D(s.x,s.y,e.x,e.y,id,data,paneID,serie);
    }

    private dist2(v:Point2D, w:Point2D): number {
        return (v.x - w.x)*(v.x - w.x) + (v.y - w.y)*(v.y - w.y);
    }

    public distToSegmentSquared(p:Point2D, v:Point2D, w:Point2D) : number {
        var l2 = this.dist2(v, w);

        if (l2 == 0) return this.dist2(p, v);

        var t = ((p.x - v.x) * (w.x - v.x) + (p.y - v.y) * (w.y - v.y)) / l2;

        if (t < 0.0) return this.dist2(p, v);
        if (t > 1.0) return this.dist2(p, w);

        return this.dist2(p, new Point2D(v.x + t * (w.x - v.x),v.y + t * (w.y - v.y)));
    }

    public distToSegmentSquaredFromPoint(p:Point2D) : number {
        return this.distToSegmentSquared(p,this.s,this.e);
    }

    public distToSegment(p, v, w) : number {
        return Math.sqrt(this.distToSegmentSquared(p, v, w));
    }
}

class LinePoint2D {
    public p: Point2D;
    public id: number;
    public data: LineItem;
    public serie: IDataSource;

    constructor(x0:number,y0:number,id:number,data: LineItem,serie: IDataSource)
    {
        this.p = new Point2D(x0,y0);
        this.id = id;
        this.data = data;
        this.serie = serie;
    }
}

export class VectorCatcher {
    private static _catchData = false;
    private static _allData: Line2D[] = [];
    private static _allContData: LinePoint2D[] = [];
    public  static active_id = 0;
    public  static _ctx: CanvasRenderingContext2D = null;
    private static _actSerie: IDataSource;

    public init() {
    }

    public static setActiveSerie(_actSerie: IDataSource)
    {
        this._actSerie = _actSerie;
    }

    private static _num = 0;

    public static setContext(ctx:CanvasRenderingContext2D)
    {
        //if (!this._catchData)
        //if (this._ctx==null)
        if (this._num==6)   this._ctx = ctx;
        this._num++;
    }

    public static clean()
    {
        this._allData = [];
        this._allContData = [];
    }

    public static catching() : boolean
    {
        return this._catchData;
    }

    public static catchingOn()
    {
        this._catchData = true;
    }

    public static catchingOff()
    {
        this._catchData = false;
    }

    // add line position on canvas in pixels
    public static addLine(x0:number,y0:number,x1:number,y1:number,id:number,data: LineItem,paneID : number,serie: IDataSource)
    {
        this._allData.push(new Line2D(x0,y0,x1,y1,id,data,paneID,serie));
    }

    public static startContLine()
    {
        this._allContData = [];
    }

    public static endContLine()
    {
        //this._allData = [];

        for (let i=0;i<this._allContData.length;i++)
        {
            if (i>0)
            {
                this._allData.push(Line2D.fromPoints(this._allContData[i-1].p,
                                                     this._allContData[i  ].p,
                                                     this._allContData[i-1].id,
                                                     this._allContData[i-1].data,
                                                     Pane.getActivePaneID(),
                                                     this._actSerie
                                                     ));
            }
        }
        this._allContData = [];
    }

    //public static addPointID(x:number,y:number,id:number)
    //{
      //  this._allContData.push(new LinePoint2D(x,y,id));
    //}

    public static addPoint(x:number,y:number,data:LineItem)
    {
        this._allContData.push(new LinePoint2D(x,y,Pane.getActivePaneID(),data,this._actSerie));
    }

    // pass mouse position on canvas in pixels
    public static findNearestVector(x:number,y:number,maxRadius:number=24.0) : number[]
    {
        let id = -1;
        let minDistance = Number.MAX_SAFE_INTEGER;
        let p = new Point2D(x,y);
        let radiusSqr = maxRadius*maxRadius;
        let nearestSeries:number[] = [];
        for (let i=0;i<this._allData.length;i++)
        if (this._allData[i].paneID==Pane.getActivePaneID())
        {
            let distance = this._allData[i].distToSegmentSquaredFromPoint(p);
         //   let valuesDiff = Math.abs(this._allData[i].s.y) - Math.abs(this._allData[i].e.y)

            if (distance<=minDistance && distance<=radiusSqr)
            {
                minDistance = distance;
                id = i;

                let serie = VectorCatcher.getSeriefromID(i);
                let findedSerieIndex = serie.serieIndex;
                let allowed = DGDrawingServiceGlobal.drawingService().excludeService.checkAccessability(findedSerieIndex);

                if(allowed)
                {
                   nearestSeries.push(i);
                }

            }
        }

        if(nearestSeries.length>0)
        {
          return nearestSeries;
        }
        else
        {
          return [-1];
        }
    }

    public static debugDraw(id:number) {
        if (id==-1) return;

        if (this._ctx!=null)
        {
            this._ctx.beginPath();
                this._ctx.moveTo(this._allData[id].s.x, this._allData[id].s.y);
                this._ctx.lineTo(this._allData[id].e.x, this._allData[id].e.y);

                if (this._allData[id].paneID==0) this._ctx.strokeStyle = '#ffff77';
                                            else this._ctx.strokeStyle = '#77ffff';
            this._ctx.stroke();
        }
    }

    public static debugDrawAll() {
        for (let i=0;i<this._allData.length;i++)
//        if (this._allData[i].paneID===1)
        {
            this.debugDraw(i);
        }
    }

    public static getTimeIDfromID(id:number) {
        if (id==-1) return -1.0;
        return this._allData[id].data.time;
    }

    public static getSeriefromID(id:number):IDataSource {
        if (id==-1) return null;
        return this._allData[id].serie;
    }

    public static logOutInfo(id:number) {
        if (id==-1) return;
        //console.log("start point: " + this._allData[id].s.x + " , " + this._allData[id].s.y);
        //console.log("end point: " + this._allData[id].e.x + " , " + this._allData[id].e.y);
        //console.log("time: " + this._allData[id].data.time);
        //console.log("price: " + this._allData[id].data.price);
        //console.log("pane ID: " + this._allData[id].paneID);
        //console.log("data size: " + this._allData.length);
    }

}
